// frontend/src/services/clientLogger.js
// Легкий клієнтський логер з відправкою на бекенд (працює на мобільних)

class ClientLogger {
    constructor() {
        const isProd = process.env.NODE_ENV === 'production';
        // В production віддаємо перевагу REACT_APP_API_BASE (URL Render)
        const envApi = process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim();
        if (envApi) {
            this.apiBase = envApi.replace(/\/$/, '');
        } else if (isProd) {
            this.apiBase = window.location.origin;
        } else {
            const protocol = window.location.protocol || 'http:';
            const hostname = window.location.hostname || 'localhost';
            const port = 10000;
            this.apiBase = `${protocol}//${hostname}:${port}`;
        }
        this.endpoint = `${this.apiBase}/api/client-log`;
        this.queue = [];
        this.flushInProgress = false;
    }

    send(level, message, extra = {}, tag = 'FRONTEND') {
        const entry = { level, message: String(message), extra, tag, ts: Date.now() };
        try {
            const payload = JSON.stringify(entry);
            // Перевага sendBeacon для фонового відправлення на мобільних
            if (navigator.sendBeacon) {
                const blob = new Blob([payload], { type: 'application/json' });
                const ok = navigator.sendBeacon(this.endpoint, blob);
                if (ok) return;
            }
            // Fallback на fetch без очікування
            fetch(this.endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: payload,
                keepalive: true,
                credentials: 'include', // Змінено з 'omit' для підтримки cookies
            }).catch((error) => {
                // Тихо ігноруємо помилки мережі для клієнтського логування
                // щоб не заспамлювати консоль
                if (process.env.NODE_ENV === 'development') {
                    console.warn('[CLIENT-LOGGER] Помилка відправки:', error.message);
                }
            });
        } catch (e) {
            // Останній шанс: кешуємо у черзі
            this.queue.push(entry);
            if (process.env.NODE_ENV === 'development') {
                console.warn('[CLIENT-LOGGER] Помилка серіалізації:', e.message);
            }
        }
    }

    info(msg, extra, tag) { this.send('INFO', msg, extra, tag); }
    warn(msg, extra, tag) { this.send('WARN', msg, extra, tag); }
    error(msg, extra, tag) { this.send('ERROR', msg, extra, tag); }
}

// Створюємо синглтон
const clientLogger = new ClientLogger();
export default clientLogger;
